import hasParentWithClassName from '@lib/hasParentWithClassName'

export default class NavigationBarOpenablePanel {
    constructor(rootElement, bodyClassName) {
        this.$dom = {
            root: rootElement,
            body: rootElement.find('.' + bodyClassName),
            window: $(window)
        }

        this.$state = {
            isOpen: false
        }

        this.bodyClassName = bodyClassName

        this.$dom.root.click(this.onRootElementClick)
        this.$dom.window.click(this.onWindowClick)

        NavigationBarOpenablePanel.openPanel = null
    }

    /**
     * Opens this panel.
     * Currently open panel (if any) will be closed.
     *
     * @public
     */
    open() {
        if (NavigationBarOpenablePanel.openPanel && NavigationBarOpenablePanel.openPanel !== this) {
            NavigationBarOpenablePanel.openPanel.close()
        }

        this.playOpenAnimation()
        this.$state.isOpen = true

        NavigationBarOpenablePanel.openPanel = this
    }

    /**
     * Closes this panel.
     *
     * @public
     */
    close() {
        this.playCloseAnimation()
        this.$state.isOpen = false

        NavigationBarOpenablePanel.openPanel = null
    }

    /** @private */
    playOpenAnimation() {
        this.$dom.root.addClass('open')
        this.$dom.body.css({
            display: 'block',
            top: 50,
            zIndex: 1090,
            opacity: 0
        }).animate({
            opacity: 1
        }, 150, 'easeOutQuad')

        this.$dom.body.css({
            borderSpacing: 95
        }).animate({
            borderSpacing: 100
        }, {
            duration: 120,
            easing: 'easeOutQuad',
            queue: false,
            step: now => {
                // Limit number to 2 decimals for smoother result.
                now = parseFloat((now / 100).toFixed(2))

                this.$dom.body.css('transform', `scale(${now})`)
            }
        })
    }

    /** @private */
    playCloseAnimation() {
        this.$dom.body.css({
            display: 'block',
            top: 50,
            opacity: 1
        }).animate({
            opacity: 0,
            top: 44
        }, 150, 'easeOutQuad', () => {
            this.$dom.body.css('display', 'none')
            this.$dom.root.removeClass('open')
        })
    }

    /** @private */
    onRootElementClick = e => {
        if (this.isElementInsidePanel(e.target)) {
            return
        }

        if (this.$state.isOpen) {
            this.close()
        } else {
            this.open()
        }

        e.stopPropagation()
    }

    /** @private */
    onWindowClick = e => {
        if (this.$state.isOpen === false || this.isElementInsidePanel(e.target)) {
            return
        }

        this.close()
    }

    isElementInsidePanel = element => {
        return hasParentWithClassName(element, this.bodyClassName)
    }
}
